//
import BranchOffice from '@/models/General/GBranchOffice'

/**
 *
 */
const fetchAll = async function() {
    //
    try {
        //
        const response = await BranchOffice.params({ get_all_results: true }).get()
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchAll
